module.exports = _.extend({
  initialize: function () {
    this.tool = INKIVE.Tool.getInstance();
    this.editor = this.tool.editor;
  },

  select: function () { this.editor.setMode('select'); },
  fhpath: function () { this.editor.setMode('fhpath'); },
  square: function () { this.editor.setMode('square'); },
  rect: function () { this.editor.setMode('rect'); },
  circle: function () { this.editor.setMode('circle'); },
  ellipse: function () { this.editor.setMode('ellipse'); },
  line: function () { this.editor.setMode('line'); }
}, Backbone.Events);
